import { forwardRef, useState, useImperativeHandle } from 'react';
import {
  Modal, Form, Input, InputNumber, Select,
} from 'antd';
import { func, any } from 'prop-types';
import { XMDD_BILLION_PRO } from '@/utils/mappingDict';

const formItemLayout = {
  labelCol: {
    sm: { span: 7 },
  },
  wrapperCol: {
    sm: { span: 24 },
  },
};

const FarmingForm = forwardRef((props, ref) => {
  const { dict } = props;
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);

  const onCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  useImperativeHandle(ref, () => ({
    open: (data) => {
      setOpen(true);
      if (data) {
        form.setFieldsValue(data);
      } else {
        form.resetFields();
      }
    },
    close: onCancel,
  }));

  const onOk = () => {
    form.validateFields().then((values) => {
      const subProjectName = dict?.[XMDD_BILLION_PRO]?.find((item) => item.val === values.subProjectCode);
      props.onSubmit({ ...values, subProjectName: subProjectName?.name });
      form.resetFields();
      setOpen(false);
    });
  };

  return (
      <Modal
        title="资金使用情况"
        maskClosable={false}
        destroyOnClose
        open={open}
        onOk={onOk}
        onCancel={onCancel}
      >
        <Form form={form} {...formItemLayout}>
          <Form.Item hidden name="id">
            <Input />
          </Form.Item>
          <Form.Item
            name="subProjectCode"
            label="子项名称"
            rules={[
              {
                required: true,
                message: '请选择子项名称',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const id = getFieldValue('id');
                  if (!value) return Promise.resolve(); // 没选值直接通过

                  // 判断新增还是编辑
                  const data = id ? dict?.dataSource?.filter((item) => item.id !== id) : dict?.dataSource;
                  // 判断数组中是否存在重复 subProjectCode
                  const existItem = data?.find(
                    (item) => item.subProjectCode === value,
                  );

                  if (existItem) {
                    return Promise.reject(new Error('当前子项名称已存在'));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Select
              options={dict[XMDD_BILLION_PRO]}
              placeholder="请选择子项名称"
              fieldNames={{ label: 'name', value: 'val' }}
            />
          </Form.Item>
          <Form.Item
            name="investment"
            label="项目计划投资"
            rules={[
              {
                required: true,
                message: '请输入项目计划投资',
              },
            ]}
          >
            <InputNumber placeholder="请输入项目计划投资" min={0} addonAfter="万元" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="investmentCompleted"
            label="已完成投资"
            rules={[
              {
                required: true,
                message: '请输入已完成投资',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const investment = getFieldValue('investment');
                  if (value === undefined || value === null) {
                    return Promise.resolve();
                  }
                  if (investment !== undefined && value > investment) {
                    return Promise.reject(
                      new Error('已完成投资不能大于项目计划投资'),
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <InputNumber placeholder="请输入已完成投资" min={0} addonAfter="万元" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="financialAidAmount"
            label="申报财政补助资金"
            rules={[
              {
                required: true,
                message: '请输入申报财政补助资金',
              },
            ]}
          >
            <InputNumber placeholder="请输入申报财政补助资金" min={0} addonAfter="万元" style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Modal>
  );
});
FarmingForm.propTypes = {
  onSubmit: func,
  dict: any,
};

export default FarmingForm;
